export type ButtonSize = "small" | "medium" | "large";
export type FontWeight = "regular" | "bold" | "semi-bold";

export const buttonSizeToFontSize = (size: ButtonSize) => {
  switch (size) {
    case "small":
      return "xsmall";
    case "medium":
      return "small";
    case "large":
      return "base";
    default:
      return "medium";
  }
};
